module.exports = __webpack_public_path__ + "img/vip.925d58a.png";